module.exports = __webpack_public_path__ + "static/media/walkthrough.f988a2c3.svg";